// extracted by mini-css-extract-plugin
module.exports = {"overlay":"tutorial_overlay__1lKxA","container":"tutorial_container__3-L1B","close":"tutorial_close__2gjPk","link":"tutorial_link__20Gzt"};